module.exports = __webpack_public_path__ + "static/media/phone.b027e13f.svg";